import React from 'react'

const UploadButton = ({
  files,
  uploading,
  onUpload,
  eventId
}) => {
  const isDisabled = uploading || files.length === 0 || !eventId || eventId === 'undefined' || eventId === null

  return (
    <div className="flex justify-end">
      {(!eventId || eventId === 'undefined' || eventId === null) && (
        <div className="text-red-400 text-sm mb-2 mr-4">
          ⚠️ Event ID missing - cannot upload
        </div>
      )}
      <button
        onClick={onUpload}
        disabled={isDisabled}
        className="bg-green-600 hover:bg-green-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-medium py-2 px-6 rounded-xl transition-all duration-300"
      >
        {uploading ? (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            Uploading...
          </div>
        ) : (
          `Upload ${files.length} file${files.length !== 1 ? 's' : ''}`
        )}
      </button>
    </div>
  )
}

export default UploadButton